import { useEffect } from 'react';
import { isEqual } from 'core/ui/utils/isEqual';
import { useRcsTemplateEditorDispatch, useRcsTemplateEditorState } from '../context/useRcsTemplateEditorContext';
import { rcsConfigToCompilerTemplateValue } from '../utils/rcsConfigToCardContent';
import { getCompilationContextFromSnapshotJson } from '../utils/getCompilationContextFromSnapshotJson';

/** Sets requiresPreview when rcsConfig or snapshot-derived compilation context differ from last compiled. */
export function useListenAndMarkRcsPreviewRequired() {
  const dispatch = useRcsTemplateEditorDispatch();
  const {
    rcsConfig,
    snapshotJson,
    lastCompiledRcsPayload,
    lastCompiledCompilationContext,
  } = useRcsTemplateEditorState();

  useEffect(() => {
    const compilationContextFromSnapshot = getCompilationContextFromSnapshotJson(snapshotJson);
    const currentPayload = rcsConfigToCompilerTemplateValue(rcsConfig);
    const configUnchanged =
      isEqual(currentPayload, lastCompiledRcsPayload) &&
      isEqual(compilationContextFromSnapshot, lastCompiledCompilationContext);

    dispatch({
      type: 'SET_PREVIEW_REQUIRED',
      payload: { requiresPreview: !configUnchanged },
    });
  }, [dispatch, lastCompiledCompilationContext, lastCompiledRcsPayload, rcsConfig, snapshotJson]);
}
